const baseURL = 'api/'

export default {
  baseURL
}



// WEBPACK FOOTER //
// ./src/default_config.js